import { PageHeader, SidebarToggle, type PageHeaderProps } from '@elbklar/ui';
import { GlobalActions } from './GlobalActions';
import { RouterLink } from './RouterLink';

interface CrmPageHeaderProps extends Omit<PageHeaderProps, 'leading' | 'zurueck'> {
  /** Pfeil zurück neben dem Sidebar-Knopf, für Detail- und Formularseiten. */
  zurueck?: { to: string; label: string };
}

/**
 * Seitenkopf jeder CRM-Seite: PageHeader aus dem Design System, vorn der Knopf
 * für die Sidebar (und auf Unterseiten der Weg zurück), hinten nach den
 * Aktionen der Seite Suche und Benutzermenü.
 */
export function CrmPageHeader({ actions, zurueck, ...rest }: CrmPageHeaderProps) {
  return (
    <PageHeader
      {...rest}
      leading={<SidebarToggle />}
      zurueck={zurueck && { label: zurueck.label, href: zurueck.to, linkAs: RouterLink }}
      actions={
        <>
          {actions}
          <GlobalActions />
        </>
      }
    />
  );
}
